import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a387d5a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a387d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a387d5a')) {
      api.createRecord('2a387d5a', component.options)
    } else {
      api.reload('2a387d5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a387d5a&scoped=true&", function () {
      api.rerender('2a387d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCLLog/index.vue"
export default component.exports